
import * as React from 'react';
import { List, Datagrid, TextField, SearchInput, ImageField, BooleanField,NumberField } from 'react-admin';

const filters = [<SearchInput source='name' alwaysOn />];

export default function ResourceList(props:any){ 
  return (
  <List {...props} filters={filters}>
    <Datagrid rowClick='edit'>
      <NumberField source="id" /><TextField source="name" /><TextField source="code" /><BooleanField source="isDefault" />
    </Datagrid>
  </List>
);
}

